import { useLocalizedData } from '../../hooks/useLocalizedData'
import { data } from './competitivePageData'
import { schema } from './schema'

export const useCompetitivePageFAQsData = () => {
  const faqsData = useLocalizedData<typeof schema>(schema, data)

  return faqsData
}
